import React, { useCallback, useRef, useState } from "react";
import { makeStyles, Popover, Button } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import HelpButtonStyle from "../styles";
import { useTranslation } from "react-i18next";
import { useApolloClient } from "@apollo/client";
import { HELPBUTTON_POPOVER_OPEN_QUERY } from "../queries";
import ContactSupport from "./ContactSupport";

const useStyles = makeStyles(HelpButtonStyle);

function HelpButton() {
  const { t } = useTranslation();
  const classes = useStyles();
  const client = useApolloClient();
  const anchorRef = useRef(null);
  const clientCache = client.readQuery({ query: HELPBUTTON_POPOVER_OPEN_QUERY });
  const [open, setOpen] = useState(Boolean(clientCache?.helpButton?.popoverOpen));

  client.watchQuery({ query: HELPBUTTON_POPOVER_OPEN_QUERY, fetchPolicy: "cache-only" }).subscribe({
    next: ({ data }) => {
      setOpen(Boolean(data?.helpButton?.popoverOpen));
    },
  });

  const handleClick = useCallback(() => {
    client.writeQuery({
      query: HELPBUTTON_POPOVER_OPEN_QUERY,
      data: { helpButton: { popoverOpen: !open } },
    });
  }, [client, open]);

  return (
    <>
      <Button className={classes.buttonStyle} variant="contained" onClick={handleClick} ref={anchorRef}>
        <HelpOutline />
        <span>{t("NavBar.HelpButton")}</span>
      </Button>
      <Popover
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClick}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <ContactSupport open={open} />
      </Popover>
    </>
  );
}

export default HelpButton;
